import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowUp, FileText, Phone } from 'lucide-react';
import WhatsAppIcon from '@/components/WhatsAppIcon';
import { PHONE_HREF } from '@/lib/contactActions';
import { usePublicRoutes } from '@/lib/publicRoutes';

const actionClassName = 'mobile-dock__action';

export default function MobileDock({ hidden = false }) {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const reduceMotion = useReducedMotion();
  const { path, label } = usePublicRoutes();
  const location = useLocation();
  const portalPath = path('portal');
  const isPortalActive = location.pathname === portalPath;

  useEffect(() => {
    const handleScroll = () => setShowBackToTop(window.scrollY > 8);

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  };

  if (hidden) return null;

  return (
    <nav className="mobile-dock lg:hidden" aria-label="Ações rápidas">
      <div className="mobile-dock__glass">
        <motion.div layout={!reduceMotion} className="mobile-dock__item">
          <a href={PHONE_HREF} className={actionClassName} aria-label="Ligar para a CDI Premium">
            <Phone aria-hidden="true" />
            <span>Ligar</span>
          </a>
        </motion.div>

        <motion.div layout={!reduceMotion} className="mobile-dock__item">
          <Link
            to={path('schedule')}
            className={actionClassName}
            aria-label="Agendar pelo WhatsApp preenchendo o formulário"
          >
            <WhatsAppIcon aria-hidden="true" />
            <span>Agendar</span>
          </Link>
        </motion.div>

        <motion.div layout={!reduceMotion} className="mobile-dock__item">
          <Link
            to={portalPath}
            className={`${actionClassName}${isPortalActive ? ' mobile-dock__action--featured' : ''}`}
            aria-label={`Acessar ${label('portal')}`}
          >
            <FileText aria-hidden="true" />
            <span>Resultados</span>
          </Link>
        </motion.div>

        <AnimatePresence initial={false}>
          {showBackToTop && (
            <motion.div
              layout={!reduceMotion}
              className="mobile-dock__item mobile-dock__top-item"
              initial={reduceMotion ? false : { flexGrow: 0, width: 0, opacity: 0 }}
              animate={{ flexGrow: 1, width: 'auto', opacity: 1 }}
              exit={reduceMotion ? { opacity: 0 } : { flexGrow: 0, width: 0, opacity: 0 }}
              transition={{ duration: reduceMotion ? 0 : 0.24, ease: 'easeOut' }}
            >
              <button
                type="button"
                className={actionClassName}
                onClick={scrollToTop}
                aria-label="Voltar ao topo da página"
              >
                <ArrowUp aria-hidden="true" />
                <span>Topo</span>
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
}
